import React, { useState, useEffect, useCallback } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  Editing,
  Texts,
  Button,
  Form,
  HeaderFilter,
  SearchPanel,
  RequiredRule,
  Popup,
  FilterPanel
} from 'devextreme-react/data-grid';
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import { Item } from 'devextreme-react/form';
import TenantService from "../../api/tenant.service";
import SpacesService from "../../api/spaces.service";
import { useRef } from 'react';
import Toast from 'components/Toast';
import { Button as ReactButton } from 'devextreme-react/button';
import {Tooltip} from 'devextreme-react';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer';
import {
  Form as DxForm,
  SimpleItem,
  GroupItem,
  Label
} from 'devextreme-react/form';

export default function App() {
  const [data, setData] = useState([])
  const [loadingText, setloadingText] = useState('Loading...');
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000
  });
  const tenant = TenantService.getTenant()
  const dropDataGridRef = useRef()
  const [isDisabled, setIsDisabled] = useState(true)
  const [isOpen, setIsOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();
  const dxFormRef = useRef();
  const [formData, setFormData] = useState({
    id: null,
    name: '',
  });
  const [prevData, setPrevData] = useState(null)

  function getData() {
    SpacesService.getSpaceTypes(tenant).then((value) => {
      let response=value.data
      setData(response.data)
      if (response.data.length === 0){
        setloadingText("No Data")
      }
    })
  }

  function onRowInserted(e){
    SpacesService.addSpaceType(e.data.name).then((space) => {
        getData()
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: space.status===200 ? 'success' : 'error',
          status: space?.data?.status ? space.data.status : space?.status,
          message: space?.data?.message ? space.data.message : space?.message,
        });
      })

  }

  function onRowRemoved(e){
    SpacesService.deleteSpaceType(e.data.id ).then((space) => {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: space.status===200 ? 'success' : 'error',
          status: space?.data?.status ? space.data.status : space?.status,
          message: space?.data?.message ? space.data.message : space?.message,
        });
        getData()
      })

  }

  function onRowUpdating(e){
    SpacesService.editSpaceType(e.oldData.id, e.newData.name ).then((space) => {
        getData()
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: space.status===200 ? 'success' : 'error', 
          status: space?.data?.status ? space.data.status : space?.status,
          message: space?.data?.message ? space.data.message : space?.message,
        });
      })
  }

  const clearFilters = () => {
    const dataGridInstance = dropDataGridRef.current.instance;
    dataGridInstance.clearFilter();
    setIsDisabled(true)
  }

  const optionChange = (e) => {
    console.log('optionChange 826');
    if (e.fullName.indexOf("filterValue") !== -1 || e.fullName.indexOf("searchPanel") !== -1) {
      if (e.value === null){
        const dataGridInstance = dropDataGridRef.current.instance();
        dataGridInstance.clearFilter();
        setIsDisabled(true)
      } else {
        setIsDisabled(false)
      }
    }
  }

  useEffect(() => {
    getData()
  }, []);

  function editRow(e){
    setEditingRow(e.row?.data)
    setFormData({
      id: e.row?.data?.id,
      name: e.row?.data?.name
    })
    setPrevData({
      id: e.row?.data?.id,
      name: e.row?.data?.name
    })
    setIsOpen(true)
  }

  function onSubmit(data){
    console.log("edited:", editingRow)
    setEditingRow(null)
    setIsOpen(false)
  }

  function onAddRow(e){
    SpacesService.addSpaceType(formData?.name).then((space) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: space.status===200 ? 'success' : 'error',
        status: space?.data?.status ? space.data.status : space?.status,
        message: space?.data?.message ? space.data.message : space?.message,
      });
    })
  }

  function onRowUpdate(e){
    SpacesService.editSpaceType(formData?.id, formData?.name ).then((space) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: space.status===200 ? 'success' : 'error', 
        status: space?.data?.status ? space.data.status : space?.status,
        message: space?.data?.message ? space.data.message : space?.message,
      });
    })
  }

  function handleSave(){
    formRef.current?.requestSubmit();
    // console.log("edited:", editingRow)
    // setIsOpen(false)
  }

  function handleCloseDrawer(){
    setEditingRow(null)
    setFormData({
      id: null,
      name: null,
    })
    setFormData(null)
    setIsOpen(false)
  }

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const result = dxFormRef.current?.validate?.();
    if (result?.isValid) {
      if(formData && formData?.id){
        onRowUpdate()
      }else{
        onAddRow()
      }
      handleCloseDrawer();
    }
  },[formData, handleCloseDrawer]);

  function handleInputChange(e){
    setEditingRow((prev) => ({
      ...prev,
      name: e.value
    }));
  }

  function handleAdd(){
    setIsOpen(true);
  }

  // {"id":"cec6a6ef-51cc-46ae-b140-6de258a287ef","name":"Floor"}


    return (
      <>
      <div className='headerHeadingPage'>
		  <div className='pageFullWidthEvents'>
        <h5 className='marginZeroEvents'>
          <b>Space Types</b>
        </h5>
        <DataGrid
          onOptionChanged={optionChange}
          ref={dropDataGridRef}
          showColumnLines={false}
          showRowLines={true}
          onRowInserted={onRowInserted}
          onRowRemoved={onRowRemoved}
          onRowUpdating={onRowUpdating}
          allowColumnResizing={true}
          height={'calc(100vh - 102px)'}
          noDataText={loadingText}
          onColumnsChanging={function (e) {
            if(e.component?.getDataSource()?._totalCount <= 0 && data.length > 0){
              setloadingText('No Data');
            }
          }}
          onToolbarPreparing={(e) => {
            e.toolbarOptions.items = e.toolbarOptions.items.filter(
              (item) => item.name !== 'addRowButton'
            );
          
            e.toolbarOptions.items.unshift({
              location: 'after',
              widget: 'dxButton',
              options: {
                icon: '',
                text: '',
                stylingMode: 'text',
                // onClick: () => e.component.addRow(),
                onClick: () => handleAdd(),
                elementAttr: {
                  id: 'addTenantButton',
                },
                template: (buttonData, buttonElement) => {
                  const container = document.createElement('div');
                  container.style.display = 'flex';
                  container.style.alignItems = 'center';
                  container.style.justifyContent = 'center';
                
                  container.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" 
                         viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" 
                         stroke-linecap="round" stroke-linejoin="round">
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  `;
                
                  buttonElement.appendChild(container);
                }
                
              },
            });
          }}
          dataSource={data}>
        <Paging enabled={false} />
        <Editing
          // texts={{
          //   addRow: 'Add a Space Type'
          // }}
          allowUpdating={false}
          allowDeleting={true}
          allowAdding={true}
          use-icons={ true }
          // mode="popup"
        >
          <Texts
            confirmDeleteMessage="Are you sure you want to delete this Space Type?"
          />
          {/* <Popup
            showTitle={true}
            width={400}
            height={400}
            title="Space Type"
            dicks={false}
          /> */}
          {/* <Form colCount={1}>
            <Item dataField="name" />
          </Form> */}
        </Editing>
        <FilterRow visible="true" apply-filter="true" />
        <HeaderFilter visible="showHeaderFilter" />
        <SearchPanel visible="true" width="240" placeholder="Search..." />
        <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
        <Column
          dataField={'name'}
          caption={"Type"}
          width={190}
          hidingPriority={8}
        >
          <RequiredRule />
        </Column>
        
        <Column
          dataField={'type'}
          caption={''}
          allowSorting={false}
          allowFiltering={false}
        >
        </Column>
        
        <Column type="buttons" width={110}>
          <Button hint="Edit" icon="edit" onClick={editRow}/>
          <Button name="delete" />
          
        </Column>
        </DataGrid>
        <Tooltip
          target="#addTenantButton"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="bottom"
        >
          <div className="custom-tooltip">Add a Space Type</div>
        </Tooltip>
        <Toast
          setParentToastConfig={setToastConfig}
          toastBody={toastConfig}
        />
        </div>
        </div>

        <SlidingDrawer 
          title={`Space Type`}
          isOpen={isOpen} 
          onClose={handleCloseDrawer}
          handleSave={handleSave}
          formData={formData}
          prevData={prevData}
        >
          {isOpen &&
          <form ref={formRef} onSubmit={handleSubmit}>
            <div>
              <DxForm
                formData={formData}
                onFieldDataChanged={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    [e.dataField]: e.value,
                  }));
                }}
                onInitialized={(e) => {
                  dxFormRef.current = e.component;
                }}
                labelLocation="top"
                showColonAfterLabel={false}
                showValidationSummary={false}
              >
                <GroupItem colCount={1}>
                  <SimpleItem
                    dataField="name"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                    }}
                    validationRules={[{ type: 'required', message: 'Type is required' }]}
                  >
                    <Label text="Type" isRequired />
                  </SimpleItem>
                </GroupItem>
              </DxForm>
            </div>
          </form>
          }
        </SlidingDrawer>
      </>
    );
}
